import React from 'react';
import {
  Box,
  VStack,
  Text,
  useColorModeValue,
  Flex,
  HStack,
  Icon,
} from '@chakra-ui/react';
import { FaFileAlt, FaPlus } from 'react-icons/fa';
import { DocumentSelector } from './DocumentSelector';
import { Config } from '../../types/config';

interface SidebarProps {
  isCollapsed: boolean;
  selectedConfig: Config | null;
  onConfigSelect?: (config: Config) => void;
  onToggleCollapse?: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ 
  isCollapsed, 
  selectedConfig,
  onConfigSelect,
  onToggleCollapse
}) => {
  const bg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.900', 'white');
  const mutedColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box
      w="full"
      h="full"
      bg={bg}
      overflow="hidden"
      display="flex"
      flexDirection="column"
    >
      {/* Document Selector Content - now includes its own header */}
      <DocumentSelector 
        selectedConfigId={selectedConfig?.id}
        onConfigSelect={onConfigSelect}
        isCollapsed={isCollapsed}
        onToggleCollapse={onToggleCollapse}
      />
    </Box>
  );
};